module.exports = __webpack_public_path__ + "static/r-dad319a64c21bae091c79a2bc8f8dad1.png";